
import { useContext, useState, useEffect } from 'react';

import { Link } from 'react-router-dom';
import { AuthContext } from '../../contexts/auth';
import axios from 'axios';
import Header from '../../components/Header';

//import './login.css';
import {api_path} from '../../server.js'; 

function UtilizarAnaliseExistente() {

  const [analiseexistente, setAnaliseExistente] = useState();
  const [userid, setUserid] = useState();
  const [analisesLista, setAnalisesLista] = useState([]);

  const [findProdutor, setFindProdutor] = useState();
  const [findCidade, setFindCidade] = useState();



  function verifica_analise_existente(){
    const storageUser = localStorage.getItem("SistemaUser");
    if(storageUser){
        let storageSistemaUser = JSON.parse(storageUser);
        //setLoading(false);
        let solo_id = storageSistemaUser.solo_id;
        let user_id = storageSistemaUser.user_id;
        setUserid(user_id);
        
        axios.post(api_path()+'sistema/analisesolo/PR_verificanalise_existente.php', {cliente_codigo: user_id, usuario_codigo: user_id, acao: 'consultar'}, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then((response) => {
            let analise_existente = response.data;
            setAnaliseExistente(analise_existente);

            })
            .catch(function (response) {
                console.log(response);
              });
    }
}


  
  function listaAnalises(){

    const bodyListaAnalises = {
      acao: 'pr_getAnalises',
      cliente_codigo: userid,
      usuario_codigo: userid,
      proprietario: '',
      cidade: ''
    }

    axios.post(api_path()+'sistema/analisesolo/analise_solo.php', bodyListaAnalises, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
    .then((response) => {
          let analises = response.data;

          setAnalisesLista(analises);

          //console.log(analises);
        })
        .catch(function (response) {
            //console.log(response);
          });

  }


useEffect(() => {
  if(userid!=""){
    listaAnalises();
    verifica_analise_existente();
    //console.log('xxxx   '+userid);
  }

  
}, [userid])



/*
  function clickUsarAnaliseExistente(analisecod){
    //analise_existente
    //alert(analise_existente);
    console.log('XXXX '+analisecod);


   
    const storageUser = localStorage.getItem("SistemaUser");
    let storageSistemaUser = JSON.parse(storageUser);
    let user_id = storageSistemaUser.user_id;

    axios.post(api_path()+'sistema/analisesolo/PR_verificanalise_existente.php', {cliente_codigo: user_id, usuario_codigo: user_id, acao: 'consultar'}, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
    .then((response) => {
          //let analise_existente = response.data;
          const storageUser0 = localStorage.getItem("SistemaUser");
          let storageSistemaUser0 = JSON.parse(storageUser0);
          
          let dataUser = {
            user_id: storageSistemaUser0.user_id,
            user_email: storageSistemaUser0.user_email,
            user_nome: storageSistemaUser0.user_nome,
            solo_id: analise_existente,
            user_token : storageSistemaUser0.user_token
          };
          
          localStorage.setItem('SistemaUser', JSON.stringify(dataUser));
          const storageUser1 = localStorage.getItem("SistemaUser");
          let storageSistemaUser1 = JSON.parse(storageUser1);

          if(storageSistemaUser1.solo_id){
              //document.location.href = '../analise-solo';
          }

        })
        .catch(function (response) {
            console.log(response);
          });
  

  }
*/
//

  function clickUsarNovaAnalise(){

    const storageUser = localStorage.getItem("SistemaUser");
    let storageSistemaUser = JSON.parse(storageUser);
    let user_id = storageSistemaUser.user_id;

    axios.post(api_path()+'sistema/analisesolo/PR_verificanalise_existente.php', {cliente_codigo: user_id, usuario_codigo: user_id, acao: 'novaanalise'}, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
    .then((response) => {

      let nova_analise = response.data;
      const storageUser0 = localStorage.getItem("SistemaUser");
      let storageSistemaUser0 = JSON.parse(storageUser0);
      
      let dataUser = {
        user_id: storageSistemaUser0.user_id,
        user_email: storageSistemaUser0.user_email,
        user_nome: storageSistemaUser0.user_nome,
        solo_id: nova_analise,
        user_token: storageSistemaUser0.user_token
      };
      //console.log(dataUser);

      localStorage.setItem('SistemaUser', JSON.stringify(dataUser));
         
      const storageUser1 = localStorage.getItem("SistemaUser");
      let storageSistemaUser1 = JSON.parse(storageUser1);

      if(storageSistemaUser1.solo_id){
          //console.log('nova analise '+storageSistemaUser1.solo_id);
          //<Redirect to="/analiseexistente" />
          document.location.href = '../analise-solo';

      }

    })
    .catch(function (response) {
        //handle error
        //console.log(response);
        console.log(response);
      });


  }




  return (

    <div className="App grid-container">
    <Header/>

      <div className="grid-container">

      <nav role="navigation">
        <ul className="breadcrumbs">
            <li><Link to="/dashboard">Home</Link></li>
            <li>Análises de Solo</li>
        </ul>
      </nav>


        <div className="grid-x grid-padding-x">
          <div className="small-12 medium-12 large-12 cell">
            <button type="button" className="success button float-right" onClick={clickUsarNovaAnalise}>Iniciar uma Nova Análise</button>
          </div>
        </div>

        <div className="card">
          <div className="card-divider"><h4>Lista das Analises Feitas</h4></div>
            <div className="card-section">

            <table className="stack">
              <thead>
                <tr>
                  <th width="300"><input type="text" className="form-control" id="find_produtor" name="find_produtor" placeholder="Nome Produtor"/></th>
                  <th><input type="text" className="form-control" id="find_cidade" name="find_cidade" placeholder="Cidade"/></th>
                  <th width="150">Table Header</th>
                  <th width="150">Table Header</th>
                </tr>
              </thead>
              <tbody>
              {
                analisesLista.map((item, index) => {
                  let codidoanalis= item.analise_id;
                  //console.log('xxxx   '+item.prop_cidade);
                  return(
                    
                <tr key={item.analise_id}>
                  <td>{item.prop_nome}</td>
                  <td>{item.prop_cidade}</td>
                  <td>{item.situacao}</td>
                  <td><a href={'../analise-solo?id='+item.analise_id} className="button tiny secondary">Editar</a><a href={'../analise-solo/laudo?id='+item.analise_id} className="button tiny secondary">Laudo</a></td>
                </tr>
                  )

                })
              }

              </tbody>
            </table>

            </div>
        </div>
      
      </div>
    </div>

  );
}

export default UtilizarAnaliseExistente;
